export function defaults (mobileSwitchDefault) {
  return {
    MOBILE_SWITCH_SELECTED: false,
    REMEMBER_ME_SELECTED: mobileSwitchDefault != null ? mobileSwitchDefault : false
  }
}
